export default __webpack_public_path__ + "static/media/SanIsidro-dia.b7000657.jpg";